<div class="container">
  <div class="row">
    <div class="staticPages">
      <h1>Google Reserve форма за спиране</h1>
      <p class="p-text">
        Моля попълнете вашата заявка и до 5 работни дни ние ще изключим
        резервациите в <b>Google Reserve</b> през нашата платформа.
      </p>
      <div class="form-wrap">
        <form #formGoogle="ngForm" id="g-reserve" class="d-flex-column" (ngSubmit)="onSubmit();">
          <div class="input-wrap d-flex-column">
            <label for="restaurant-name" class="input-label">Име на заведението и град</label
            ><input required [(ngModel)]="formData.name" id="restaurant-name" name="restaurant-name" type="text" class="input-text" placeholder="Пример: Cactus - София"/>
          </div>
          <label for="exclude-e2e" class="checkbox-wrap">
            Желая да бъда изключен от <b>"Google Reserve end-to-end"</b>
            <input [(ngModel)]="formData.greserveEtE" type="checkbox" name="exclude-e2e" id="exclude-e2e">
            <span class="checkmark"></span>
          </label>
          <label for="exclude-buisness" class="checkbox-wrap">
            Желая да бъда изключен от <b>"Google Reserve Business link"</b>
            <input [(ngModel)]="formData.greserveB" type="checkbox" name="exclude-buisness" id="exclude-buisness">
            <span class="checkmark"></span>
          </label>

          <button [disabled]="formGoogle.invalid || !formData.greserveB && !formData.greserveEtE" type="submit" class="btn btn-primary">Направи заявка</button>
        </form>
      </div>
    </div>
  </div>
</div>
